export default ({ formData, schema, uiSchema }) => {
  const newFormData = formData ? formData.join('\n') : undefined;
  return { schema, uiSchema, formData: newFormData };
};



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/changeQuestionType/toTextArea/fromTextList.js